import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { ROUTE_DENIED } from 'constants/routerPath';

const adminRoles = ['can_park_adminapp_v3_admin'];
const allowedRoles = [...adminRoles, 'can_park_adminapp_v3_user'];
export function useCANparkAdminAppAccessControl() {
	const { userInfo } = useSelector(selectUserInfo);
	const navigate = useNavigate();
	const [isAdmin, setIsAdmin] = useState(false);
	const assignedCustomer = userInfo.customerId;

	useEffect(() => {
		if (!userInfo.contactId) return;
		// Check if user has access first:
		const isAllowed = userInfo.roles.some((role: any) =>
			allowedRoles.includes(role),
		);
		const _isAdmin = userInfo.roles.some((role: any) =>
			adminRoles.includes(role),
		);
		if (!isAllowed) {
			navigate(ROUTE_DENIED);
		}
		setIsAdmin(_isAdmin);
	}, [navigate, userInfo]);

	return { isAdmin, assignedCustomer };
}
